import { type RefObject, useContext } from 'react';

import { ComparisonContext } from '../ComparisonContext';
import Button from './Button';

const Buttons = ({
  containerRef,
  scrollTo,
  smaller = false
}: {
  containerRef: RefObject<HTMLDivElement>;
  scrollTo: (props: { left?: number; top?: number }) => void;
  smaller?: boolean;
}) => {
  const { isStickyBarVisible, showPrev, showNext } = useContext(ComparisonContext);

  function handleArrowClick(next?: boolean) {
    if (containerRef.current) {
      const comparisonColumnWidth = 256;

      const currentScrolledItemCount = containerRef.current.scrollLeft / comparisonColumnWidth;
      const scrollBy =
        (next ? Math.ceil(currentScrolledItemCount) : Math.floor(currentScrolledItemCount)) *
        comparisonColumnWidth;

      scrollTo({
        left:
          scrollBy / comparisonColumnWidth === currentScrolledItemCount
            ? next
              ? scrollBy + comparisonColumnWidth
              : scrollBy - comparisonColumnWidth
            : scrollBy
      });
    }
  }

  return (
    <>
      <Button
        show={showPrev && (!isStickyBarVisible || smaller)}
        onClick={() => handleArrowClick(false)}
        smaller={smaller}
      />
      <Button
        next
        show={showNext && (!isStickyBarVisible || smaller)}
        onClick={() => handleArrowClick(true)}
        smaller={smaller}
      />
    </>
  );
};

export default Buttons;
